export default __webpack_public_path__ + "static/leave-review-8bd7fa8580e0d3f3ac993e3a6b4c6540.png";